export enum LevelType {
    Group = 1,
    Company = 2
}

export enum AreaKey {
    Groups = 'corporate-groups',
    Companies = 'companies'
}

export class SelectedLevel {
    id: number;
    type: LevelType;
    public constructor(initId, initType) {
        this.id = initId;
        this.type = initType;
    }

}
